import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { rgba } from "polished";

import { Card } from "antd";

const props = {
    children: PropTypes.any,
    className: PropTypes.string,

    border: PropTypes.string,
    shadow: PropTypes.bool,
    padding: PropTypes.number,
    style: PropTypes.object,
};

const LSCard = ({ children, className, border, shadow, style, padding = 24 }) => {
    return (
        <Wrapper
            className={className}
            border={border}
            shadow={(shadow !== undefined ? shadow : true).toString()}
            padding={padding}
            style={{ ...(style || {}) }}
        >
            {children}
        </Wrapper>
    );
};

const Wrapper = styled(Card)`
    border: ${(props) => (props.border ? `1px solid ${props.border}` : "none")};
    box-shadow: ${(props) => (props.shadow === "true" ? `0 5px 20px ${rgba("#000", 0.08)}` : "none")};

    overflow: visible;

    background-color: #fff;

    .ant-card-body {
        padding: ${(props) => (props.padding !== undefined ? props.padding : "24")}px;

        &::before,
        &::after {
            display: none;
        }
    }
`;

LSCard.propTypes = props;

export default LSCard;
